import PerformanceChasten from './PerformanceChasten'
import PerformanceAsset from './PerformanceAsset'
import PerformanceEducate from './PerformanceEducate'
import PerformanceReputation from './PerformanceReputation'
import PerformanceIndicator from './PerformanceIndicator'

export default {
  PerformanceIndicator, // ผลรวมคะแนน
  PerformanceChasten, // ตักเตือน
  PerformanceAsset, // ทรัพย์สิน
  PerformanceEducate, // อบรม
  PerformanceReputation // ความดี

}



// WEBPACK FOOTER //
// ./src/components/HRM/EmpPerformance/index.js